import { ChevronIcon } from "@assets/icons";
import { useInViewSSR } from "@design-system/hooks";
import { currentIndexAtom, projectsAtom } from "@modules/home/atoms";
import { trans } from "@mongez/localization";
import { motion } from "framer-motion";

export function ProjectsNavigation() {
  const currentIndex = currentIndexAtom.useValue();
  const projects = projectsAtom.useValue();

  // Calculate max index based on responsive breakpoints
  const getMaxIndex = () => {
    const width = typeof window !== "undefined" ? window.innerWidth : 0;
    let slidesPerView = 1;

    if (width >= 1024) slidesPerView = 3;
    else if (width >= 640) slidesPerView = 2;
    else slidesPerView = 1;

    return Math.max(0, projects.length - slidesPerView);
  };

  const maxIndex = getMaxIndex();

  const { ref, isInView } = useInViewSSR<HTMLDivElement>({
    once: true,
    margin: "-100px",
  });

  return (
    <motion.div
      ref={ref}
      className="_h-[37.375rem] z-30 translate-y-[-50%] lg:col-span-4 lg:h-[30rem]"
      initial={{ y: "-140%" }}
      animate={isInView ? { y: "0%" } : { y: "-100%" }}
      transition={{ duration: 0.8 }}
    >
      <div className="flex h-full w-full items-start justify-between rounded-[2rem] bg-dark-blue px-4 py-8 lg:flex-col lg:px-11 lg:py-12">
        <div className="flex flex-col gap-7">
          <div className="!h-1 w-16 rounded-[2rem] bg-bright-orange lg:h-[0.375rem]" />
          <h3 className="w-[70%] text-2xl font-medium lg:text-5xl lg:leading-[3.5625rem]">
            {trans("ourRecentProjects")}
          </h3>
          <p className="max-w-[321px] text-white text-opacity-80 lg:text-xl">
            {trans("toBeWinning")}
          </p>
        </div>
        <div className="flex items-center gap-4">
          <button
            className="projects-button-prev disabled:opacity-25"
            disabled={currentIndex <= 0}
          >
            <ChevronIcon
              className="w-6 rotate-180 rtl:-rotate-0"
              color="#fff"
            />
          </button>
          <button
            className="projects-button-next disabled:opacity-25"
            disabled={currentIndex >= maxIndex}
          >
            <ChevronIcon
              color="#fff"
              className="w-6 rotate-0 rtl:-rotate-180"
            />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
